import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class AmortizationService {
  constructor(private http: HttpClientService) {}

  public creditSimulation(options): Observable<any> {
    return this.http
      .post("/api/amortization/credit_simulation", options)
      .pipe(tap((_) => console.log("AmortizationService.creditSimulation: Ok.")));
  }
  public creditSimulationPDF(options): Observable<any> {
    return this.http
      .post("/api/amortization/credit_simulation_pdf", options, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("AmortizationService.creditSimulationPDF: Ok.")));
  }
}
